// map businessTypeId and businessCategoryId to it's string
const defaultValue = 'MOKA';

export function convertBusinessTypeIdtoString(number, businessTypeEnum) {
  const found = businessTypeEnum.filter(
    businessType => number === businessType.id
  )[0];
  return found ? found.name : defaultValue;
}
export function convertBusinessTypeStringtoId(str, businessTypeEnum) {
  const found = businessTypeEnum.filter(
    businessType => str === businessType.name
  )[0].id;
  return found ? found.id : defaultValue;
}

export function convertBusinessCategoryIdtoString(
  number,
  businessCategoryEnum
) {
  const found = businessCategoryEnum.filter(
    businessCategory => number === businessCategory.id
  )[0];
  return found ? found.name : defaultValue;
}
export function convertBusinessCategoryStringtoId(str, businessCategoryEnum) {
  const found = businessCategoryEnum.filter(
    businessCategory => str === businessCategory.name
  )[0].id;
  return found ? found.id : defaultValue;
}
